import {
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  AgComboBoxEditor,
  CrudbarNavComponent,
  JkBaseComponent,
  EntityType,
  GridInitOption,
  JkEntityV2,
  JkJobService,
  JkeditComponent,
  idNameItem,
  MaterialModule,
  JkJobOption,
  jobParamKindList,
  JkJobOptionColumns
} from 'jk-service';
import {
  SysseService,
} from '../_service_sys';
import { JkaggridComponent } from 'jk-advcom';
import { JsonEditorComponent } from 'jk-service';
import { JkJobKind, PageKind, jkRestReturnClass, JkComboboxComponent } from 'jk-service';
import { MatTab, MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MatTableDataSource } from '@angular/material/table';

/**
 * @description 派發器參數組件
 * 用於管理和配置不同類型作業的參數設定
 * 支援API、批次作業和報表三種類型的參數配置
 */
@Component({
  selector: 'app-dispatcher-param',
  standalone: true,
  imports: [
    CrudbarNavComponent,
    JsonEditorComponent, MaterialModule,
    JkComboboxComponent, JkeditComponent],
  templateUrl: './dispatcher-param.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dispatcher-param.component.css',
})
export class DispatcherParamComponent extends JkBaseComponent {
  doTableCancel() {
    this._itemList = JSON.parse(this._values);
    this.doRefresh();
  }
  doTableOk() {
    this._values = JSON.stringify(this.itemList);
    this.doRefresh();
  }
  /** @description 組件類型識別碼 */
  override comType: string = 'dispatcher-param';
  tabIndex: number = 0;
  apiMethod: string = 'GET';
  apiMethodList: idNameItem[] = [
    { id: 'GET', name: 'GET' },
    { id: 'POST', name: 'POST' },
    { id: 'PUT', name: 'PUT' },
    { id: 'DELETE', name: 'DELETE' },
  ];
  apiUrl: string = '';
  apiBody: any = undefined;
  apiJob: JkJobService = new JkJobService();
  hasError = false;
  errorMessage = '';
  /**
   * @description 值變更事件處理函數
   * @param $event 變更後的字串值
   */
  onValueChange($event: string) {
    this.hasError = false;
    this.errorMessage = '';
    try {
      this.apiBody = JSON.parse($event);
    } catch (error: any) {
      this.hasError = true;
      this.errorMessage = `JSON解析錯誤: ${error.message}`;
    }
  }

  /**
   * @description JSON資料變更事件處理函數
   * @param $event 變更後的JSON資料
   */
  onJsonChange($event: any) {
    this.apiBody = $event;
  }

  /**
   * @description 主題變更事件處理函數
   * @param $event 是否為暗色主題
   */
  onThemeChange($event: boolean) {
    throw new Error('方法尚未實作');
  }


  /** @description 系統服務參考 */
  @Input() sysseSrv!: SysseService;

  /**
   * @description 作業風格類型
   * A: API作業
   * B: 批次作業
   * R: 報表作業
   */
  @Input()
  _style: string = 'A';
  /**
   * @description 取得風格類型值
   * @returns 風格類型字串
   */
  get style(): string {
    return this._style;
  }

  /**
   * @description 設定風格類型值
   * @param value 風格類型字串
   */
  set style(value: string) {
    this._style = value;
  }

  /** @description JSON資料物件 */
  jsonData: any;

  /** @description 是否使用暗色主題 */
  isDarkTheme: boolean = true;

  /** @description 作業參數種類清單 */
  jobParamKindList = jobParamKindList;

  //jobParamTypeList = jobParamTypeList;

  /** @description CRUD導航欄元件引用 */
  crudbarNav!: CrudbarNavComponent;

  /** @description 網格初始化選項 */
  gridInitOpt: GridInitOption = {
    pageKind: PageKind.base,
    programId: 'dispatcherParam',
    sortField: '',
    sort: 'asc', // gridSortType.asc,
    defaultSort: null,
  }

  /**
   * @description 取得作業類型
   * @returns 作業類型列舉值
   */
  get jobKind(): JkJobKind {
    if (this.style === 'R') {
      return JkJobKind.Report;
    }
    if (this.style === 'B') {
      return JkJobKind.Batch;
    }
    if (this.style === 'A') {
      return JkJobKind.Api;
    }
    return JkJobKind.Api;
  }

  /**
   * @description 取得選項名稱
   * @returns 根據風格類型返回對應的選項名稱
   */
  get optName(): string {
    if (this.style === 'R') {
      return 'ReportOption';
    }
    if (this.style === 'B') {
      return 'BatchOption';
    }
    if (this.style === 'A') {
      return 'ApiOption';
    }
    return 'ApiOption';
  }

  /** @description 參數字串的私有儲存變數 */
  _values: string = '';
  /**
   * @description 取得參數字串
   * @returns 當前參數字串
   */
  @Input()
  get values(): string {
    return this._values;
  }

  /**
   * @description 設定參數字串並轉換為項目清單
   * @param value 參數字串
   */
  set values(value: string) {
    if (typeof value !== 'string') {
      return;
    }
    this._values = value;
    try {
      this._itemList = JSON.parse(this._values);
      this.doRefresh();
    } catch (error) {

    }
  }
  /** @description 值變更事件發射器 */
  @Output() valuesChange = new EventEmitter<string>();

  _itemList: JkJobOption[] = [];
  get itemList(): JkJobOption[] {
    if (!this.values || this.values === '') {
      this._itemList = [];
      return [];
    }
    try {
      //this._itemList = JSON.parse(this.values);
    } catch (error) {
      this._itemList = [];
    }
    return this._itemList;
  }
  set itemList(value: JkJobOption[]) {
    this._itemList = value;
    this._values = JSON.stringify(this._itemList);
    //this.doParamSubmit();
    if (this.valuesChange) {
      this.valuesChange.emit(this._values);
    }
  }

  /** @description 作業服務實例 */
  job: JkJobService = new JkJobService();

  /** @description 實體服務實例 */
  //srv: JkEntityV2 = new JkEntityV2();
  /**
   * @description 建構函式
   */
  constructor() {
    super();
  }

  /**
   * @description 元件初始化生命週期鉤子
   */
  override ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * @description 視圖初始化後的生命週期鉤子
   * 初始化CRUD工具列
   */
  override ngAfterViewInit() {
    this.initCrudbar(this.crudbarNav);
  }



  /**
   * @description 初始化CRUD工具列
   * @param crudbar CRUD導航欄元件
   */
  initCrudbar(crudbar: any) {

    /*
    this.crudbarNav.cbInsert = this.doUIInsert.bind(this);
    this.crudbarNav.cbDelete = this.doUIDelete.bind(this);
    this.crudbarNav.cbCancel = this.doUICancel.bind(this);

    this.crudbarNav.cbPost = this.doUIPost.bind(this);
    this.crudbarNav.cbEdit = this.doUIEdit.bind(this);

    this.crudbarNav.cbFirst = this.gridwin.onFirstRow.bind(this.gridwin);
    this.crudbarNav.cbPrevious = this.gridwin.onPreviousRow.bind(this.gridwin);
    this.crudbarNav.cbNext = this.gridwin.onNextRow.bind(this.gridwin);
    this.crudbarNav.cbLast = this.gridwin.onLastRow.bind(this.gridwin);
    */
  }


  /**
   * @description 根據參數內容修正風格類型
   * @param params 參數字串
   */
  fixStyleByParams(params: string) {
    if (params.startsWith('<BatchOption>')) {
      if (this.style !== 'B') {
        this.style = 'B';
      }
    }
    if (params.startsWith('<ReportOption>')) {
      if (this.style !== 'R') {
        this.style = 'R';
      }
    }
    if (params.startsWith('<ApiOption>')) {
      if (this.style !== 'A') {
        this.style = 'A';
      }
    }
    if (params.startsWith('{')) { // JSON格式
      if (this.style !== 'A') {
        this.style = 'A';
      }
    }
  }

  /**
   * @description 將項目清單轉換為參數字串
   * @returns 轉換後的XML格式參數字串
   */
  itemListToParams(): string {
    let paramStr = '';
    return JSON.stringify(this.itemList);
    /*let optName = 'ReportOption';
    if (this.style === JkJobKind.Report || this.style === 'R') {
      // "報表"
      optName = 'ReportOption';
    }
    if (this.style === JkJobKind.Batch || this.style === 'B') {
      // "批次"
      optName = 'BatchOption';
    }
    if (this.style === JkJobKind.Api || this.style === 'A') {
      // "API"
      optName = 'ApiOption';
    }*/
  }



  /**
   * @description 執行新增操作
   */
  doInsert() {
    let item: JkJobOption = {
      kind: '',
      caption: '',
      text: '',
      name: '',
      type: '',
      ps: '',
    };
    this._itemList.push(item);
    this.doRefresh();
  }

  /**
   * @description 執行編輯操作
   */
  doUIEdit() {
  }

  /**
   * @description 執行提交操作
   * @param $event 事件物件
   * @returns 操作是否成功的Promise
   */
  async doUIPost($event: any): Promise<boolean> {
    let bool = true;
    return bool;
  }

  /**
   * @description CRUD工具列準備完成的事件處理
   * @param $event CRUD導航欄元件
   */
  onCrudbarReady($event: any) {
    this.crudbarNav = $event;
  }

  /**
   * 處理主標籤頁變更事件
   * @param $event 標籤變更事件
   */
  override onMasterTabChange($event: MatTabChangeEvent) {
    super.onMasterTabChange($event);
    this.tabChange($event.index);
  }
  tabChange(index: number) {
    //console.log('tabChange',index);
    if (index === 2) {
      let ret = this.apiJob.itemListToApi(this.itemList);
      if (ret.ok) {
        this.apiMethod = ret.method || 'GET';
        this.apiUrl = ret.url || '';
        this.apiBody = ret.body || undefined;
      }
    }
  }
  dataSource = new MatTableDataSource<JkJobOption>();
  displayedColumns: string[] = JkJobOptionColumns;
  doApiOk() {
    let ret = new jkRestReturnClass();
    //http://localhost:9085/uty/reportAllSSL?remain=10
    let itemList: JkJobOption[] = this.apiJob.apiToItemList(this.apiMethod,
      this.apiUrl, this.apiBody, ret);
    if (ret.result) {
      this.itemList = [...itemList];
      this.doRefresh();
      alert('OK');
      return;
    } else {
      alert('Error:' + ret.getResultError());
    }
    /*export const jobParamKindList: idNameItem[] = [
  { id: 'TjkCheckBox', name: '勾選' },
  { id: 'TjkComboBox', name: '下拉' },
  { id: 'TComboBox', name: '下拉2' },
  { id: 'TJKRange', name: '範圍' },
  { id: 'TjkMultiSelect', name: '多選' },
  { id: 'TJKDBEdit', name: '單行' },
  { id: 'query', name: 'url參數' },
  { id: 'body', name: 'body參數' },
  { id: 'method', name: '方法' },
  { id: 'host', name: '主機網址' },// 含http,port
  { id: 'path', name: '路徑' },
  ]; */


  }
  doApiCancel() {
    // TODO:
    this.doRefresh();

  }
  doDelete(name: string) {
    let idx = this._itemList.findIndex(x => x.name === name);
    if (idx >= 0) {
      this._itemList.splice(idx, 1);
    }
    this.doRefresh();
  }
  doRefresh() {
    this._values = JSON.stringify(this.itemList);
    this.dataSource.data = this.itemList;
  }

}
